import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
} from "@coreui/react"
import { Flex, Input, Typography, Select, DatePicker } from "antd"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  addRace,
  getRaces,
  editRace,
} from "src/store/Slices/UsersRatingSlice"
import { clubsAction } from "src/store/Slices/Administrator/ClubsSlice"
import dayjs from "dayjs"

const AddEditRaceModal = ({ visible, setVisible, setPage, setPageSize }) => {
  const dispatch = useDispatch()

  const clubsData = useSelector((state) => state.ClubsSlice?.clubsList)

  const [formData, setFormData] = useState({
    participantsCount: null,
    clubId: null,
    isComplited: false,
    registeredCount: null,
    clubName: "",
    raceDate: null,
  })

  useEffect(() => {
    if (visible.open) {
      dispatch(clubsAction({ flag: "get" }))
    }
  }, [visible.open, dispatch])

  useEffect(() => {
    if (visible.flag === "edit" && visible.raceInfo) {
      setFormData({
        participantsCount: visible.raceInfo.participantsCount || null,
        clubId: visible.raceInfo.clubId || null,
        isComplited: visible.raceInfo.isComplited || false,
        registeredCount: visible.raceInfo.registeredCount || null,
        clubName: visible.raceInfo.club || "",
        raceDate: visible.raceInfo.date ? dayjs(visible.raceInfo.date) : null,
      })
    }
  }, [visible.flag, visible.raceInfo])

  useEffect(() => {
    if (visible.flag === "add" && visible.open) {
      setFormData({
        participantsCount: null,
        clubId: null,
        isComplited: false,
        registeredCount: null,
        clubName: "",
        raceDate: null,
      })
    }
  }, [visible.flag, visible.open])

  const clubOptions =
    clubsData?.data?.value?.rows?.map((club) => ({
      label: club.name,
      value: club.id,
    })) || []

  const handleSubmit = () => {
    const submitData = {
      clubId: formData.clubId,
      participantsCount: formData.participantsCount,
      registeredCount: formData.registeredCount,
      isComplited: formData.isComplited,
      raceDate: formData.raceDate ? formData.raceDate.format("YYYY-MM-DDTHH:mm:ss") : null,
    }

    switch (visible.flag) {
      case "add": {
        dispatch(addRace(submitData)).then(() => {
          dispatch(getRaces())
          setVisible({ open: false, flag: "", raceInfo: null })
          setPage(1)
          setPageSize(20)
        })
        break
      }
      case "edit": {
        const editData = {
          id: visible.raceInfo?.id,
          ...submitData,
        }
        dispatch(editRace(editData)).then(() => {
          dispatch(getRaces())
          setVisible({ open: false, flag: "", raceInfo: null })
        })
        break
      }
      default:
        break
    }
  }

  const handleClose = () => {
    setVisible({ open: false, flag: "", raceInfo: null })
  }

  const handleClubChange = (value, option) => {
    setFormData({
      ...formData,
      clubId: value,
      clubName: option?.label || "",
    })
  }

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      raceDate: date,
    })
  }

  return (
    <CModal
      alignment='center'
      visible={visible.open}
      onClose={handleClose}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle>
          {visible.flag === "add"
            ? "Добавление гонки"
            : "Редактирование гонки"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <div>
            <Typography.Title level={5}>Дата и время проведения</Typography.Title>
            <DatePicker
              showTime
              format="YYYY-MM-DD HH:mm"
              value={formData.raceDate}
              onChange={handleDateChange}
              placeholder="Выберите дату и время"
              style={{ width: "100%" }}
            />
          </div>

          <div>
            <Typography.Title level={5}>Ограничение участников</Typography.Title>
            <Input
              type='number'
              value={formData.participantsCount}
              onChange={(e) =>
                setFormData({ ...formData, participantsCount: e.target.value })
              }
              placeholder='Введите ограничение'
              min={0}
            />
          </div>

          <div>
            <Typography.Title level={5}>Клуб</Typography.Title>
            <Select
              options={clubOptions}
              value={formData.clubId}
              onChange={handleClubChange}
              placeholder='Выберите клуб'
              style={{ width: "100%" }}
              showSearch
              optionFilterProp='label'
            />
          </div>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={handleClose}
          style={{ color: "#fff" }}
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton onClick={handleSubmit} style={{ color: "#fff" }} color='primary'>
          {visible.flag === "add" ? "Добавить" : "Сохранить"}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AddEditRaceModal